import '../../scss/pages/advertiser.scss';

import { initAos } from "./aos";
import { initHeader } from "../index/header";
import { intMobileMenu } from './mobileMenu';
import { initHero } from "./hero";
import { initScroll } from "../index/utils";
import { initTraffic } from "./traffic";
import { initFeatures } from "./features";
import { initReviews } from "./reviews";
import { initCookiesBar } from "../common/cookies-bar";
import { initCookieHubBar } from "../common/cookiehub-bar";

const initCookiesBars = () => {
  initCookieHubBar();
  initCookiesBar();
}

document.addEventListener('DOMContentLoaded', function(){
  initAos();
  initScroll();
  initHeader();
  intMobileMenu();
  initHero();
  initTraffic();
  initFeatures();
  initReviews();
  setTimeout(initCookiesBars, 7000);
})
